import {Component} from 'react'
import PropTypes from 'prop-types'
import ReactRating from 'react-rating'
import Star from 'react-feather/dist/icons/star.js'
import XCircle from 'react-feather/dist/icons/x-circle.js'

import './Rating.scss'

class Rating extends Component {
  static propTypes = {
    quiet: PropTypes.bool,
    readOnly: PropTypes.bool,
    name: PropTypes.string.isRequired,
    remove: PropTypes.bool,
    value: PropTypes.number,
  }

  static defaultProps = {
    quiet: true,
    readOnly: true,
    name: 'rating',
    remove: false,
    value: 0,
  }

  constructor(props) {
    super(props)
    this.state = {
      value: this.props.value,
    }
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    if (this.props.value !== prevProps.value) {
      this.setState({value: this.props.value})
    }
  }

  onChange = (value) => {
    if(this.props.onChange) {
      this.setState({value})
      this.props.onChange({
        name: this.props.name,
        value,
      })
    }
  }

  render() {
    return (
      <div className={`rating ${this.props.className} ${this.props.alignBottom ? 'align-bottom' : ''}`}>
        {this.props.label ?
          <span className={`rating-label ${this.props.align ? 'align': ''}`}>{this.props.label}</span>
          : ''
        }
        <div className="rating-star">
          <div>
            <ReactRating
              emptySymbol={<Star strokeWidth={0} fill={this.props?.starColor ?? '#bdc8d8'} />}
              fullSymbol={<Star strokeWidth={0} fill={this.props?.starColor ?? '#FF942D'} />}
              fractions={2}
              start={0}
              stop={5}
              readonly={this.props.readOnly}
              quiet={this.props.quiet}
              initialRating={this.state?.value ?? 0}
              onChange={this.onChange}
            />
          </div>
          {this.props.remove && this.state.value > 0 &&
          <div className="rating-remove">
            <span onClick={() => this.onChange(0)}><XCircle size={20} /></span>
          </div>
          }
        </div>
      </div>
    )
  }
}

export default Rating